module.exports = __webpack_public_path__ + "static/media/2.89d16a0f.jpg";